import React, { useEffect, useState } from "react";
import IconLabelComponent from "./IconLabel.component";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Drawer,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { grey } from "@mui/material/colors";
import { useTranslation } from "react-i18next";
import FilterListIcon from "@mui/icons-material/FilterList";

const FiltersAccordionComponent = ({
  width = 130,
  onChange = () => { },
  options,
  checked,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const matchDownSm = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(true);

  const handleToggle = () => {
    setOpen(!open);
  };

  useEffect(() => {
    if (matchDownSm) {
      setOpen(false);
    }
    // eslint-disable-next-line
  }, [matchDownSm]);

  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent
        sx={{
          borderRadius: 3,
          backgroundColor: "rgb(41,50,60)",
          boxShadow: "0 6px 12px 0 rgb(0 0 0 / 16%)",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          "&.MuiCardContent-root": {
            padding: {xs:0.5, sm:2},
          },
        }}
      >
        <Box
          onClick={() => setOpen(!open)}
          sx={{
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          {matchDownSm ? (
            <Box
              sx={{
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <FilterListIcon />
            </Box>
          ) : (
            <Typography align="left">{t("filters")}</Typography>
          )}
          {!matchDownSm &&
            (open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />)}
        </Box>

        {!matchDownSm ? (
          open && (
            <Box>
              <Divider
                sx={{ borderColor: grey[700], mb: 1, ml: -2, mr: -2, mt: 1 }}
              />
              <Box
                component="div"
                sx={{
                  minHeight: 41,
                  position: "relative",
                  width: width,
                }}
              >
                <Box
                  component="div"
                  sx={{
                    position: "absolute",
                    backgroundColor: theme.palette.primary.main,
                    borderRadius: 2,
                    width: 25,
                    height: "100%",
                    top: 2,
                    right: 0,
                    opacity: 0.7,
                  }}
                />

                <Grid container>
                  {options?.map((item, index) => (
                    <Grid
                      item
                      xs={12}
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <IconLabelComponent
                        item={item}
                        isSelected={checked[item.name]}
                        onChange={() => onChange(item)}
                        icon={item?.icon}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Box>
          )
        ) : (
          <Drawer
            anchor="bottom"
            onClose={handleToggle}
            open={open}
            sx={{
              zIndex: 1405,
              backgroundColor: "rgba(68,65,65,0.10)",
              "& .MuiPaper-root": {
                backgroundColor: "rgba(68,65,65,1)",
                borderRadius: "25px 25px 0 0",
                maxHeight: '50%'
              },
            }}
          >
            <Grid container>
              <Grid item xs={12}>
                <Typography align="left" p={2} variant="h4" color="white">
                  {t("filters")}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item container xs={12}>
                <List sx={{ width: "100%" }}>
                  {options?.map((item, index) => (
                    <ListItemButton
                      key={index}
                      selected={checked[item.name]}
                      onClick={() => onChange(item)}
                      sx={{
                        color: "#fff",
                        "&.Mui-selected": {
                          backgroundColor: theme.palette.secondary.main,
                        },
                        "&.MuiListItemButton-root.Mui-selected:hover": {
                          backgroundColor: theme.palette.secondary.main,
                        },
                        "&.MuiListItemButton-root:hover": {
                          backgroundColor: "rgba(68,65,65,1)",
                        },
                      }}
                    >
                      <ListItemIcon>{item?.icon}</ListItemIcon>
                      <ListItemText
                        primary={t(item.label)}
                        sx={{
                          "& .MuiListItemText-primary": { color: "white" },
                        }}
                      />
                    </ListItemButton>
                  ))}
                </List>
              </Grid>
            </Grid>
          </Drawer>
        )}
      </CardContent>
    </Card>
  );
};

export default FiltersAccordionComponent;
